var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"mZ5J2_x39S9NjFKwsw3du"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["shop@i4s"]={id:"mZ5J2_x39S9NjFKwsw3du"};
      